/**
* Licensed Materials - Property of IBM
* IBM Watson Analytics (C) Copyright IBM Corp. 2018
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*
*/
define([], function() {
	class ConverterInterface {
		constructor(definition) {
			if (definition == undefined || !definition.src || !definition.target) {
				throw new Error('ConverterInterface constructor expects object of type {src: "...", target: "..."} for configuration');
			}
			this._src = definition.src;
			this._target = definition.target;
		}

		get src() {
			return this._src;
		}

		get target() {
			return this._target;
		}

		convert(/* src, target, spec */) {
			// Needs to be implemented by provider in client
			return Promise.resolve();
		}

		validate(/* spec, type */) {
			// Needs to be implemented by provider in client
			return true;
		}
	}

	return ConverterInterface;
});
